import { Link } from 'react-router-dom';

import {
  Box as BaseBox,
  Icon,
  IconName,
  styled,
  Typography,
  usePreferenceContext,
  useTheme,
} from '@sbv-clients/ui-shared';

import { SideBarMenuItem } from '../types';
import { LabelToIconMapper } from './constants';

const Label = styled(Typography)<{
  active: boolean | undefined;
  parentId: boolean;
}>`
  font-weight: ${({ parentId }) => (parentId ? 400 : 500)};
  font-size: 14px;
  overflow: hidden;
  white-space: nowrap;
  line-height: 20px;
  color: ${({ parentId, theme }) =>
    parentId ? theme.background.darkGrey : theme.background.darkGrey3};
`;

const Box = styled(BaseBox)`
  color: ${(props) => props.theme.text?.secondary};
  align-items: center;
  justify-content: center;

  &:hover,
  &[data-active='true'] {
    border-radius: 10px;
  }
`;

const SidebarNavSection = ({
  item,
  active,
  isChild,
  withLink,
  isMinimisedView,
}: {
  item: SideBarMenuItem;
  active?: boolean;
  isChild?: boolean;
  isMinimisedView?: boolean;
  withLink?: boolean;
}) => {
  const theme = useTheme();
  const { isSidebarMinimized } = usePreferenceContext();
  const body = (
    <Box
      data-active={active ? 'true' : ''}
      display="flex"
      alignItems="center"
      pl={isSidebarMinimized ? 0 : '12px'}
      gap={'12px'}
      sx={{
        padding: '12px 20px',
        cursor: 'pointer',
        borderRadius: 1,
        marginLeft: isChild ? 4 : 0,
        marginBottom: '6px',
        backgroundColor: active
          ? item?.parentId
            ? theme.background.lightGrey3
            : theme.colors.primary.light
          : null,
        '&:hover': {
          backgroundColor: item?.parentId
            ? theme.background.lightGrey3
            : theme.colors.primary.light,
        },
      }}
    >
      <Icon
        sx={{
          color: active ? theme.colors.primary.main : theme.background.darkGrey,
        }}
        name={LabelToIconMapper[item?.label as IconName]}
      />
      <Label parentId={!!item.parentId} active={active} flexGrow={1}>
        {item.label}
      </Label>
    </Box>
  );

  if (withLink) {
    return <Link to={item.link ?? ''}>{body}</Link>;
  }
  return body;
};

export default SidebarNavSection;
